import PaymentsIcon from "@mui/icons-material/Payments";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import { Roles } from "data/authData";

export const resolveUserRole = (user) => {
	const assigned = user?.role || {};
	if (assigned.ADMIN) return "ADMIN";

	const roleKeys = Roles.map((role) => role.key);
	return (
		Object.keys(assigned).find((role) => roleKeys.includes(role)) || "VIEWER"
	);
};

export const COMMISSION_WRITE_ROLES = ["ADMIN", "PUBLISHER"];

export const canEditCommissionMaster = (user) =>
	COMMISSION_WRITE_ROLES.includes(resolveUserRole(user));

export const mboSalePaymentDashboardServices = {
	mbo_sale_working: {
		name: "MBO Sale Working",
		key: "mbo_sale_working",
		display: true,
		icon: <PaymentsIcon />,
		types: {
			dashboard: {
				name: "Dashboard",
				description:
				"Download payment working results by bill date range as CSV.",
				key: "dashboard",
				display: true,
				icon: <DashboardOutlinedIcon />,
			},
			sale_data: {
				name: "Sale Data & Offers",
				description:
					"Upload sale CSV, sync to BigQuery, and run offer application in one workflow.",
				key: "sale_data",
				display: true,
				icon: <UploadFileIcon />,
			},
			offers: {
				name: "Offer Checker",
				description:
					"Look up a barcode and bill date to see which offers apply — and why.",
				key: "offers",
				display: true,
				icon: <LocalOfferOutlinedIcon />,
			},
			commission_master: {
				name: "Commission Master",
				description:
					"Manage MBO distributor commission rates by store, site code, and effective date.",
				key: "commission_master",
				display: true,
				icon: <PercentOutlinedIcon />,
			},
		},
	},
};
